export default "__VITE_ASSET__DSSnRE10__"